import { i18n } from '@/plugins/i18n'

export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      ident: '',
      plate: '',
      vehicleTypeId: undefined,
      sensors: [],
      odometerUsingGps: false,
      ftpEnabled: false,
      style: 'TRAILER',
      customFields: [],
      trailerProfile: {
        id: null,
        name: '',
        trailerStyle: '',
        plannedMonthlyMileage: null,
        serviceInterval: null,
        height: null,
        weight: null,
        tareWeight: null,
        tareWeightManualOverride: false,
        tailLift: false,
        moffetMounts: false,
        group: '',
        vehicleType: '',
        vehicleMake: '',
        ebsValveType: '',
        vehicleGrossWeight: '',
        customFields: []
      },
      accountId: ''
    }
  },
  defaultSensor () {
    return {
      id: null,
      name: '',
      sensorType: '',
      parameter: '',
      slug: '',
      formula: '{value}',
      calculationType: 'FORMULA',
      calculationTable: []
    }
  },
  sensorTypes () {
    return [
      {
        value: 'GENERAL',
        text: i18n.t('units.sensors.general')
      },
      {
        value: 'ODOMETER',
        text: i18n.t('units.sensors.odometer')
      }
    ]
  },
  vehicleStyles () {
    return [
      {
        value: 'CAR',
        text: i18n.t('units.vehicleTypes.car')
      },
      {
        value: 'VAN',
        text: i18n.t('units.vehicleTypes.van')
      },
      {
        value: 'RIGID_TRUCK',
        text: i18n.t('units.vehicleTypes.rigidTruck')
      },
      {
        value: 'ARTIC_TRUCK',
        text: i18n.t('units.vehicleTypes.articTruck')
      },
      {
        value: 'TRAILER',
        text: i18n.t('units.vehicleTypes.trailer')
      },
      {
        value: 'TRAILER_12',
        text: i18n.t('units.vehicleTypes.trailer12')
      }
    ]
  }
}
